import { render } from "./mped-amortization-excluding-asset-view.vue?vue&type=template&id=2d072d62"
import script from "./mped-amortization-excluding-asset-view.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-amortization-excluding-asset-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/amortization/main-asset/mped-amortization-excluding-asset-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d072d62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d072d62', __exports__)) {
    api.reload('2d072d62', __exports__)
  }
  
  module.hot.accept("./mped-amortization-excluding-asset-view.vue?vue&type=template&id=2d072d62", () => {
    api.rerender('2d072d62', render)
  })

}


export default __exports__